import React from "react";
import "../Styles/stats.css";

const Section3 = () => {
  return (
    <>
      <div className="Home_numberSection__tf0Ni">
        <div>
          <div className="Home_numberSectionHeading1__a65Wb">
            Koo in <br /> numbers
          </div>
          <div className="Home_numberSectionHeading2__koVkf">
            Overwhelming response across the globe
          </div>
        </div>
        <table>
          <tbody>
            <tr>
              <td className="Home_tableCell1__nr4hu">
                <div className="Home_tableCellDiv__xNled">
                  <div className="Home_tableHeading1__Q1hHg">100+ </div>
                  <div className="Home_tableHeading2__mzDw8">Countries</div>
                </div>
              </td>
              <td className="Home_tableCell2__LXfb8">
                <div className="Home_tableCellDiv__xNled">
                  <div className="Home_tableHeading1__Q1hHg">60M+</div>
                  <div className="Home_tableHeading2__mzDw8">Downloads</div>
                </div>
              </td>
            </tr>
            <tr>
              <td className="Home_tableCell3__5enFI">
                <div className="Home_tableCellDiv__xNled">
                  <div className="Home_tableHeading1__Q1hHg">9000+</div>
                  <div className="Home_tableHeading2__mzDw8">
                    Eminent Profiles
                  </div>
                </div>
              </td>
              <td className="Home_tableCell4__Id_X4">
                <div className="Home_tableCellDiv__xNled">
                  <div className="Home_tableHeading1__Q1hHg">1000+</div>
                  <div className="Home_tableHeading2__mzDw8">
                    Topics to explore
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Section3;
